import { render, staticRenderFns } from "./setting-advanced-greetLibrary.vue?vue&type=template&id=e897bf24&"
import script from "./setting-advanced-greetLibrary.vue?vue&type=script&lang=js&"
export * from "./setting-advanced-greetLibrary.vue?vue&type=script&lang=js&"
import style0 from "./setting-advanced-greetLibrary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports